import { Gender } from '~/lib/gender/types'

/**
 * 一覧系ページのパスの性別プレフィックスを返す
 * @param gender Gender
 * @returns `men-` or `women-` or `kids-` or ` ` (empty string)
 */
export const getGenderPathPrefix = (gender: Gender) => {
  switch (gender) {
    case 'men':
      return 'men-'
    case 'women':
      return 'women-'
    case 'kids':
      return 'kids-'
    default:
      return ''
  }
}
